<template>
  <div :class="componentClassName">
    <div class="m-response-flow-item__icon">
      <a-icon icon="phone-incoming-call-outline" :color="iconColor" />
    </div>
    <div class="m-response-flow-item__options">
      <a-switch v-model="activated" :label="label" :disabled="viewOnly" @change="handleActivationChange" />
      <a-button
        :id="'button_' + label"
        :disabled="!activated"
        variant="round"
        size="small"
        :label="viewOnly ? '参照' : '設定'"
        color="grey"
        :inline="true"
        @click="handleConfigClick"
      />
    </div>
    <div v-if="responseMode" class="m-response-flow-item__info">
      <div :id="'name_' + label" class="m-response-flow-item__info-setting-name">{{ settingName }}</div>
      <div :id="'value_' + label" class="m-response-flow-item__info-selected-value">{{ selectedValue }}</div>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AIcon from '@/components/atoms/icon';
import AButton from '@/components/atoms/button';
import ASwitch from '@/components/atoms/switch';

export default {
  name: 'm-response-flow-item',
  components: {
    AIcon,
    AButton,
    ASwitch,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    itemIndex: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Boolean,
      default: null,
    },
    responseMode: {
      type: String,
      default: null,
      validator(value) {
        return value.match(/(null|user|transfer)/);
      },
    },
    settingName: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    voiceDXPhoneNumberList: {
      type: Array,
      default: new Array(0),
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['activate', 'deactivate', 'config', 'change', 'update:modelValue'],
  data() {
    return {
      activated: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('m-response-flow-item', this.activated ? 'active' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
    iconColor() {
      return this.activated ? 'white' : 'grey';
    },
    selectedGroupName() {
      return `${this.value}が着信`;
    },
    selectedPhoneNumber() {
      return `${this.value} に転送`;
    },
    selectedVoiceDXName() {
      return `${this.voiceDXPhoneNumberList.find(v => v.value === this.value).label} に転送`;
    },
    selectedValue() {
      if (this.responseMode === 'user') {
        return this.selectedGroupName;
      } else if (this.responseMode === 'transfer') {
        return this.selectedPhoneNumber;
      } else if (this.responseMode === 'voiceDX') {
        return this.selectedVoiceDXName;
      }
      return '';
    },
  },
  watch: {
    active(val, oldValue) {
      this.activated = val;
    },
    modelValue(val, oldValue) {
      this.activated = val;
    },
  },
  mounted() {
    if (this.active) {
      this.activated = this.active;
    }
    if (this.modelValue) {
      this.activated = this.modelValue;
    }
  },
  methods: {
    handleActivationChange(e) {
      const event = e.target.checked ? 'activate' : 'deactivate';
      this.$emit(event, this.itemIndex);
      this.$emit('update:modelValue', this.activated);
      this.$emit('change', e);
    },
    handleConfigClick() {
      this.$emit('config', this.itemIndex);
    },
  },
};
</script>
